// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const WidgetLists: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#231f20",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 14 19" width={width} height={height}>
            <path
                fill="currentColor"
                d="M0 1.938C0 1.006.784.25 1.75.25h10.5c.966 0 1.75.756 1.75 1.688v15.535c0 .429-.36.777-.806.777a.84.84 0 0 1-.448-.13L7 14.425 1.254 18.12a.83.83 0 0 1-.448.13c-.445 0-.806-.348-.806-.777zm1.75-.563a.575.575 0 0 0-.583.563v14.885l5.509-3.54a.6.6 0 0 1 .648 0l5.51 3.54V1.938a.575.575 0 0 0-.584-.563z"
            />
        </svg>
    );
};

export default React.memo(WidgetLists);
